import React from 'react'

/**
 * Single-select pills — dates, time slots, anything with a small fixed set of
 * choices where a dropdown would hide the options.
 *
 * `options` take { value, label } or { value, top, main, bottom } for the
 * stacked date form (weekday / day number / month).
 */
const OptionPills = ({ options = [], value, onChange, ariaLabel }) => (
  <div className='app-modal__pills' role='group' aria-label={ariaLabel}>
    {options.map((option) => {
      const selected = String(option.value) === String(value)
      return (
        <button
          key={option.value}
          type='button'
          className={`app-modal__pill ${selected ? 'app-modal__pill--on' : ''}`.trim()}
          aria-pressed={selected}
          disabled={option.disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label !== undefined ? (
            option.label
          ) : (
            <>
              <div className='app-modal__pill-top'>{option.top}</div>
              <div className='app-modal__pill-main'>{option.main}</div>
              <div className='app-modal__pill-top'>{option.bottom}</div>
            </>
          )}
        </button>
      )
    })}
  </div>
)

export default OptionPills
